import { encodeFunctionData, erc20Abi, erc721Abi } from 'viem'

import { ERC1155ABI } from '~/constants/tokens'
import { IAddress } from '~/types'
import { EvmAddress } from '~/utils/address'

export const getTokenTransferBytes = (
  recipient: IAddress,
  amount: bigint,
): string => {
  const calldata = encodeFunctionData({
    abi: erc20Abi,
    functionName: 'transfer',
    args: [EvmAddress.format(recipient), amount],
  })

  return calldata
}

export const getERC721TokenTransferBytes = (
  sender: IAddress,
  recipient: IAddress,
  tokenId: bigint,
): string => {
  const calldata = encodeFunctionData({
    abi: erc721Abi,
    functionName: 'safeTransferFrom',
    args: [EvmAddress.format(sender), EvmAddress.format(recipient), tokenId],
  })

  return calldata
}

export const getERC1155TokenTransferBytes = (
  sender: IAddress,
  recipient: IAddress,
  params: { tokenId: bigint; amount: bigint },
): string => {
  const { tokenId, amount } = params
  const calldata = encodeFunctionData({
    abi: ERC1155ABI,
    functionName: 'safeTransferFrom',
    args: [
      EvmAddress.format(sender),
      EvmAddress.format(recipient),
      tokenId,
      amount,
      '0x',
    ],
  })

  return calldata
}
